import script from "./PanelFun.vue?vue&type=script&lang=js"
export * from "./PanelFun.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__